import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import styles from './SystemMessage.scss';

export default function SystemMessage({ type, time, payload }) {
    const { t } = useTranslation('inbox');
    const text =
        type === 'assign' ? (
            <>
                {t('systemMessage.assign_to')} <strong>{payload.username}</strong> {time.format('HH:mm')}
            </>
        ) : (
            type
        );

    return (
        <div className={styles.root}>
            <div className={styles.body}>
                <div className={styles.text}>{text}</div>
            </div>
        </div>
    );
}

SystemMessage.propTypes = {
    type: PropTypes.string,
    time: PropTypes.object,
    payload: PropTypes.object,
};
